import styled from 'styled-components';
import { Redirect, useHistory, useLocation } from 'react-router-dom';
import { useQuery } from '@apollo/client';
import Button from '../../elements/Button';
import { MANDANT_BY_REGISTERID } from './MandantRegisterHeadline';
import { registrationDisabledText } from '../../constants';
import { mandantSettings } from '../../queries/mandantSetting';
import AuthenticationForm from './AuthenticationForm';

const ButtonRow = styled.div`
  text-align: right;

  margin-top: 10px;

  button {
    margin-left: 10px;
  }
`;

const RegisterAtAnother = ({ user, mandant, mandantSettings }) => {
  const history = useHistory();
  const location = useLocation();

  if (mandantSettings?.registrationEnabled === false) {
    return (
      <div>
        <div>{registrationDisabledText}</div>
        <br />
        <div>
          Bist du bereits bei dieser Organisation registriert? Dann klicke auf
          den OK Button, um den Einloggvorgang abzuschließen.
        </div>

        <ButtonRow>
          <Button
            onClick={() => {
              history.push('/');
            }}
            size='small'>
            OK
          </Button>
        </ButtonRow>
      </div>
    );
  }

  return (
    <div>
      Du bist derzeit eingeloggt als:
      <ul>
        <li>
          {user.firstName} {user.lastName}
        </li>
        <li>{user.email}</li>
      </ul>
      <p>
        Möchtest du Dich jetzt bei <b>{mandant.name}</b> registrieren?
      </p>

      {mandantSettings?.newUserEnterMobile === 'show' ||
      mandantSettings?.newUserEnterMobile === 'required' ||
      mandantSettings?.newUserEnterAddress === 'required' ? (
        <p>
          Die folgenden zusätzlichen Angaben werden vom Anbieter angefordert:
        </p>
      ) : null}

      <AuthenticationForm
        history={history}
        location={location}
        mandantSettings={mandantSettings}
        user={user}
        purpose="registerAtAnother"
      />
    </div>
  );
};

const RegisterAtAnotherDataWrapper = ({ mandantRegisterId, user }) => {
  const { loading, data } = useQuery(MANDANT_BY_REGISTERID, {
    variables: { mandantRegisterId },
    fetchPolicy: 'network-only',
  });
  const { data: mandantSettingsData, loading: mandantSettingsLoading } =
    useQuery(mandantSettings, {
      variables: { registerId: mandantRegisterId },
      pollInterval: 60 * 1000,
    });

  if (loading || mandantSettingsLoading) {
    return <div>Bitte warten ...</div>;
  }

  if (!data || !data.mandantByRegisterId) {
    return <Redirect to='/' />;
  }

  return (
    <RegisterAtAnother
      user={user}
      mandant={data.mandantByRegisterId}
      mandantSettings={mandantSettingsData.getMandantSettings}
      registerId={mandantRegisterId}
    />
  );
};

export default RegisterAtAnotherDataWrapper;
